namespace InvData {

    export class SelectionSetHelper {

        /**
         * A list of assets which should have resourceId fields will be union'd with an existing selectionSetRef to create
         * a combined selectionSetRef.
         */ 
        public static unionAssetListWithSelectionSet(assetList: any[], selectionSetRef: any) {

            if (!assetList || assetList.length === 0) {
                return selectionSetRef;
            }

            let resourceIds = [];
            for (let asset of assetList) {
                if (asset.resourceId) {
                    resourceIds.push(asset.resourceId);
                }
            }

            return SelectionSetHelper.unionResourceIdsWithSelectionSet(resourceIds, selectionSetRef);
        }

        public static unionResourceIdsWithSelectionSet(resourceIds: any[], selectionSetRef: any) {

            if (!resourceIds || resourceIds.length === 0) {
                return selectionSetRef;
            }

            let assetListBlock = {
                blockType: "FixedAsset",
                fixedAssetListResourceIds: resourceIds
            };

            let unionSelectionSetRef: any = {
                custom: {
                    blocks: [assetListBlock]
                }
            };

            if (selectionSetRef) {
                unionSelectionSetRef.mods = [
                    {
                        op: "Add",
                        set: selectionSetRef
                    }
                ];
            }

            return unionSelectionSetRef;
        }
    }

}